module.exports = __webpack_public_path__ + "media/college_advice/Test_Prep_widget_040710-d7b25b19.png";